import {z} from '@hono/zod-openapi';

import {priceReportMarketSchema} from './priceReportMarketSchema';

/**
 * A stored price report as the detail and create operations answer it: the 21 fields the legacy
 * `PRR_priceReport_response` type declares plus `purchasePrice`, in the order the module's
 * `PRICE_REPORT_DETAIL_KEYS` lists them. A field the stored payload does not carry is absent.
 *
 * Documented, never used to parse: the payload is already shaped in the module's domain layer, so
 * running it through a schema again would only risk a second, divergent filter. The values come
 * from the stored legacy JSON, which no schema ever validated, so they stay open here. `markets`
 * is the exception: its entries declare the keys this port added (`priceReportMarketSchema`).
 */
export const priceReportResponseSchema = z
  .object({
    id: z.unknown(),
    /** The joined request row's id, supplied by the module rather than read from the payload. */
    idRequest: z.string().optional(),
    created: z.unknown(),
    market: z.unknown(),
    /** Metada stored an empty collection as `null`. */
    markets: z.array(priceReportMarketSchema).nullish(),
    currency: z.unknown(),
    vehicle: z.unknown(),
    additionalSettings: z.unknown(),
    purchasePrice: z.unknown(),
    sellingPrice: z.unknown(),
    attractiveness: z.unknown(),
    arguments: z.unknown(),
    accuracy: z.unknown(),
    levels: z.unknown(),
    neighborAdIds: z.unknown(),
    turnover: z.unknown(),
    featuresLevel: z.unknown(),
    customerId: z.unknown(),
    vehicleId: z.unknown(),
    couponNumber: z.unknown(),
    serviceCode: z.unknown(),
    status: z.unknown(),
  })
  .openapi('PriceReportResponse');
